"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
require("core-js/modules/es6.function.name");
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("el-row", [_c("el-form", {
    staticStyle: {
      "padding-top": "20px",
      "padding-left": "20px"
    },
    attrs: {
      inline: true,
      model: _vm.formInline
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "搜索"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: ""
    },
    model: {
      value: _vm.formInline.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.formInline, "keyword", $$v);
      },
      expression: "formInline.keyword"
    }
  })], 1), _vm._v(" "), _c("el-form-item", {
    attrs: {
      label: "状态"
    }
  }, [_c("el-select", {
    attrs: {
      placeholder: "请选择"
    },
    model: {
      value: _vm.formInline.active,
      callback: function callback($$v) {
        _vm.$set(_vm.formInline, "active", $$v);
      },
      expression: "formInline.active"
    }
  }, [_c("el-option", {
    attrs: {
      label: "待审核",
      value: "待审核"
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: "上架",
      value: "上架"
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: "下架",
      value: "下架"
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: "删除",
      value: "删除"
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: "拒绝",
      value: "拒绝"
    }
  }), _vm._v(" "), _c("el-option", {
    attrs: {
      label: "全部",
      value: ""
    }
  })], 1)], 1), _vm._v(" "), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary",
      icon: "el-icon-search",
      size: "small"
    },
    on: {
      click: _vm.handleFilter
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c("el-button", {
    attrs: {
      type: "default",
      icon: "el-icon-search",
      size: "small"
    },
    on: {
      click: _vm.reload
    }
  }, [_vm._v("重置")])], 1)], 1)], 1), _vm._v(" "), _c("el-row", {
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    staticStyle: {
      padding: "0 20px"
    },
    attrs: {
      md: 24
    }
  }, [_c("div", {
    staticStyle: {
      color: "red"
    }
  }, [_vm._v("产品名和图片上只要包含任意一个敏感词就拒绝，敏感词：京东，礼品卡，e卡，易卡，E卡，劵，礼包，手机，旅游卡")]), _vm._v(" "), _c("div", {
    staticStyle: {
      color: "red",
      "margin-top": "10px"
    }
  }, [_vm._v("\n          商品金额最多3万，最多60期，不允许一天一扣，最少45天，拆单金额不能区别太大，所有金额都不能带小数\n          ")]), _vm._v(" "), _c("el-table", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isDesktop,
      expression: "isDesktop"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }, {
      name: "el-height-adaptive-table",
      rawName: "v-el-height-adaptive-table",
      value: {
        bottomOffset: 50
      },
      expression: "{ bottomOffset: 50 }"
    }],
    ref: "target",
    staticStyle: {
      width: "100%",
      "margin-top": "6px"
    },
    attrs: {
      data: _vm.dataList.results,
      "highlight-current-row": "",
      "row-key": "id",
      height: "100",
      stripe: "",
      border: "",
      "header-cell-style": {
        background: "#eaedf4",
        fontWeight: "700"
      }
    }
  }, [_c("el-table-column", {
    attrs: {
      type: "index",
      label: "序号",
      width: "60"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "id",
      label: "商品id"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "goodNo",
      label: "商品编号"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "name",
      label: "商品名称",
      width: "250"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "cost_rule",
      label: "扣款规则",
      width: "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.cost_rule) + "\n            "), _c("el-button", {
          attrs: {
            type: "primary",
            link: "",
            size: "small"
          },
          on: {
            click: function click($event) {
              return _vm.getCostRule(scope.row.cost_rule);
            }
          }
        }, [_vm._v("查看具体规则")])];
      }
    }])
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "active",
      label: "是否上架"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.active == "上架" ? _c("el-tag", {
          attrs: {
            type: "success"
          }
        }, [_vm._v("上架")]) : scope.row.active == "下架" ? _c("el-tag", {
          attrs: {
            type: "warning"
          }
        }, [_vm._v("下架")]) : scope.row.active == "待审核" ? _c("el-tag", {
          attrs: {
            type: "primary"
          }
        }, [_vm._v("待审核")]) : scope.row.active == "删除" ? _c("el-tag", {
          attrs: {
            type: "primary"
          }
        }, [_vm._v("删除")]) : _c("el-tag", {
          attrs: {
            type: "danger"
          }
        }, [_vm._v("拒绝")])];
      }
    }])
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "cost_money",
      label: "成本金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.cost_money) + "元")])];
      }
    }])
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "shou_money",
      label: "首付扣款总额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.shou_money) + "元")])];
      }
    }])
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "shou_cost_num",
      label: "首付扣款期数"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.shou_cost_num) + "期")])];
      }
    }])
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "order_mode",
      label: "下单方式"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(scope.row.order_mode == 1 ? "先用后付" : "先付后用"))])];
      }
    }])
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "create_time",
      label: "创建时间"
    }
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      prop: "",
      label: "产品图片",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            type: "primary",
            round: "",
            size: "small"
          },
          on: {
            click: function click($event) {
              return _vm.getimgClick(scope.row);
            }
          }
        }, [_vm._v("查看产品图片")])];
      }
    }])
  }), _vm._v(" "), _c("el-table-column", {
    attrs: {
      fixed: "right",
      label: "操作",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            type: "primary",
            round: "",
            size: "small",
            plain: ""
          },
          on: {
            click: function click($event) {
              return _vm.handleClick(scope.row, "上架");
            }
          }
        }, [_vm._v("通过")]), _vm._v(" "), _c("el-button", {
          attrs: {
            type: "danger",
            round: "",
            size: "small",
            plain: ""
          },
          on: {
            click: function click($event) {
              return _vm.handleClick(scope.row, "拒绝");
            }
          }
        }, [_vm._v("拒绝")])];
      }
    }])
  })], 1), _vm._v(" "), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isDesktop,
      expression: "!isDesktop"
    }],
    staticClass: "mobile-list"
  }, [_c("el-row", {
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    staticStyle: {
      padding: "0 10px"
    },
    attrs: {
      span: 24
    }
  }, [_vm.listLoading ? _c("div", {
    staticClass: "loading-container"
  }, [_c("i", {
    staticClass: "el-icon-loading"
  }), _vm._v(" "), _c("span", [_vm._v("加载中...")])]) : _c("div", [_vm._l(_vm.dataList.results, function (item, index) {
    return _c("div", {
      key: item.id,
      staticClass: "product-card"
    }, [_c("div", {
      staticClass: "card-header"
    }, [_c("span", {
      staticClass: "product-index"
    }, [_vm._v("序号：" + _vm._s(index + 1))]), _vm._v(" "), _c("el-tag", {
      attrs: {
        type: _vm.getStatusType(item.active),
        size: "mini"
      }
    }, [_vm._v("\n                    " + _vm._s(_vm.getStatusText(item.active)) + "\n                  ")])], 1), _vm._v(" "), _c("div", {
      staticClass: "card-body"
    }, [_c("div", {
      staticClass: "product-info"
    }, [_c("div", {
      staticClass: "info-section"
    }, [_c("div", {
      staticClass: "info-row"
    }, [_c("span", {
      staticClass: "info-label"
    }, [_vm._v("商品ID:")]), _vm._v(" "), _c("span", {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(item.id))])]), _vm._v(" "), _c("div", {
      staticClass: "info-row"
    }, [_c("span", {
      staticClass: "info-label"
    }, [_vm._v("商品名称:")]), _vm._v(" "), _c("span", {
      staticClass: "info-value product-name"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c("div", {
      staticClass: "info-row"
    }, [_c("span", {
      staticClass: "info-label"
    }, [_vm._v("创建时间:")]), _vm._v(" "), _c("span", {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(item.create_time))])])]), _vm._v(" "), _c("div", {
      staticClass: "info-section"
    }, [_c("div", {
      staticClass: "info-row"
    }, [_c("span", {
      staticClass: "info-label"
    }, [_vm._v("成本金额:")]), _vm._v(" "), _c("span", {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(item.cost_money) + "元")])]), _vm._v(" "), _c("div", {
      staticClass: "info-row"
    }, [_c("span", {
      staticClass: "info-label"
    }, [_vm._v("订单总金额:")]), _vm._v(" "), _c("span", {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(item.money) + "元")])]), _vm._v(" "), _c("div", {
      staticClass: "info-row"
    }, [_c("span", {
      staticClass: "info-label"
    }, [_vm._v("订单总期数:")]), _vm._v(" "), _c("span", {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(item.cost_num) + "期")])])]), _vm._v(" "), _c("div", {
      staticClass: "info-section"
    }, [_c("div", {
      staticClass: "info-row"
    }, [_c("span", {
      staticClass: "info-label"
    }, [_vm._v("下单方式:")]), _vm._v(" "), _c("span", {
      staticClass: "info-value"
    }, [_vm._v(_vm._s(item.order_mode == 1 ? "先用后付" : "先付后用"))])]), _vm._v(" "), _c("div", {
      staticClass: "info-row"
    }, [_c("span", {
      staticClass: "info-label"
    }, [_vm._v("扣款规则:")]), _vm._v(" "), _c("div", {
      staticClass: "info-value rule-info"
    }, [_vm._v("\n                          " + _vm._s(item.cost_rule)), _c("el-button", {
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        type: "primary",
        size: "mini"
      },
      on: {
        click: function click($event) {
          return _vm.getCostRule(item.cost_rule);
        }
      }
    }, [_vm._v("\n                            查看规则\n                          ")])], 1)])])]), _vm._v(" "), _c("div", {
      staticClass: "card-actions"
    }, [_c("el-button", {
      staticStyle: {
        "margin-right": "10px"
      },
      attrs: {
        type: "primary",
        size: "small"
      },
      on: {
        click: function click($event) {
          return _vm.getimgClick(item);
        }
      }
    }, [_vm._v("\n                      查看图片\n                    ")]), _vm._v(" "), _c("el-button", {
      staticStyle: {
        "margin-right": "10px"
      },
      attrs: {
        type: "success",
        size: "small",
        plain: ""
      },
      on: {
        click: function click($event) {
          return _vm.handleClick(item, "上架");
        }
      }
    }, [_vm._v("\n                      通过\n                    ")]), _vm._v(" "), _c("el-button", {
      attrs: {
        type: "danger",
        size: "small",
        plain: ""
      },
      on: {
        click: function click($event) {
          return _vm.handleClick(item, "拒绝");
        }
      }
    }, [_vm._v("\n                      拒绝\n                    ")])], 1)])]);
  }), _vm._v(" "), !_vm.dataList.results || _vm.dataList.results.length === 0 ? _c("div", {
    staticClass: "empty-state"
  }, [_c("i", {
    staticClass: "el-icon-document"
  }), _vm._v(" "), _c("p", [_vm._v("暂无商品数据")])]) : _vm._e()], 2)])], 1)], 1), _vm._v(" "), _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.dataList.count > 0,
      expression: "dataList.count > 0"
    }],
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    },
    attrs: {
      total: _vm.dataList.count,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.page_size
    },
    on: {
      "update:page": function updatePage($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function updateLimit($event) {
        return _vm.$set(_vm.listQuery, "page_size", $event);
      },
      pagination: _vm.getList
    }
  }), _vm._v(" "), _c("el-dialog", {
    attrs: {
      title: "商品图片",
      visible: _vm.showImageDialog,
      width: _vm.isDesktop ? "40%" : "90%",
      "before-close": _vm.closeImageDialog
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.showImageDialog = $event;
      }
    }
  }, [_c("div", {
    staticClass: "image-container"
  }, [_vm.good_img ? _c("img", {
    class: _vm.isDesktop ? "desktop-image" : "mobile-image",
    attrs: {
      src: _vm.good_img,
      alt: "商品图片"
    }
  }) : _c("div", {
    staticClass: "no-image"
  }, [_vm._v("暂无图片")])]), _vm._v(" "), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: _vm.closeImageDialog
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c("el-dialog", {
    attrs: {
      title: _vm.isDesktop ? "可视化扣款规则" : "扣款规则",
      visible: _vm.dialogFormVisibleRule,
      width: _vm.isDesktop ? "40%" : "95%",
      "before-close": _vm.closeRule
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogFormVisibleRule = $event;
      }
    }
  }, [_c("div", {
    staticClass: "ruledata"
  }, [_c("div", {
    staticClass: "ruletitle"
  }, [_vm._v("商品扣款规则：" + _vm._s(_vm.currentRule))]), _vm._v(" "), !_vm.isDesktop ? _c("div", {
    staticClass: "mobile-rule-list"
  }, _vm._l(_vm.newRuledata, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "mobile-rule-item"
    }, [_c("div", {
      staticClass: "mobile-rule-header"
    }, [_vm._v("\n                天数序号：" + _vm._s(index + 1) + " \n              ")]), _vm._v(" "), _c("div", {
      staticClass: "mobile-rule-content"
    }, [_c("div", {
      staticClass: "rule-field"
    }, [_c("span", {
      staticClass: "field-label"
    }, [_vm._v("扣款日期：")]), _vm._v(" "), _c("el-date-picker", {
      staticStyle: {
        width: "100%"
      },
      attrs: {
        type: "date",
        placeholder: "选择日期",
        format: "yyyy-MM-dd",
        "value-format": "yyyy-MM-dd",
        size: "mini"
      },
      model: {
        value: item.date,
        callback: function callback($$v) {
          _vm.$set(item, "date", $$v);
        },
        expression: "item.date"
      }
    })], 1), _vm._v(" "), _c("div", {
      staticClass: "rule-field"
    }, [_c("span", {
      staticClass: "field-label"
    }, [_vm._v("扣款金额：")]), _vm._v(" "), _c("span", {
      staticClass: "field-value"
    }, [_vm._v(_vm._s(item.money) + " 元")])]), _vm._v(" "), _c("div", {
      staticClass: "rule-field"
    }, [_c("span", {
      staticClass: "field-label"
    }, [_vm._v("拆单数：")]), _vm._v(" "), _c("span", {
      staticClass: "field-value"
    }, [_vm._v(_vm._s(item.splitnum))])])]), _vm._v(" "), item.splitmoney && item.splitmoney.length > 0 ? _c("div", {
      staticClass: "split-details"
    }, [_c("div", {
      staticClass: "split-title"
    }, [_vm._v("拆单明细")]), _vm._v(" "), _vm._l(item.splitmoney, function (splitItem, splitIndex) {
      return _c("div", {
        key: splitIndex,
        staticClass: "split-item"
      }, [_c("span", [_vm._v("第" + _vm._s(splitIndex + 1) + "期：")]), _vm._v(" "), _c("span", [_vm._v(_vm._s(splitItem.money) + " 元")])]);
    })], 2) : _vm._e()]);
  }), 0) : _c("div", _vm._l(_vm.newRuledata, function (item, index) {
    return _c("div", {
      key: index
    }, [_c("div", {
      staticClass: "rulecontent"
    }, [_c("div", {
      staticClass: "ruleitem"
    }, [_c("div", {
      staticClass: "itemlabel"
    }, [_vm._v("天数序号")]), _vm._v(" "), _c("div", {
      staticClass: "itemvalue"
    }, [_vm._v(_vm._s(index + 1))])]), _vm._v(" "), _c("div", {
      staticClass: "ruleitem"
    }, [_c("div", {
      staticClass: "itemlabel"
    }, [_vm._v("扣款日期")]), _vm._v(" "), _c("div", {
      staticClass: "itemvalue"
    }, [_c("el-date-picker", {
      attrs: {
        type: "date",
        placeholder: "选择日期",
        format: "yyyy 年 MM 月 dd 日",
        "value-format": "yyyy-MM-dd"
      },
      model: {
        value: item.date,
        callback: function callback($$v) {
          _vm.$set(item, "date", $$v);
        },
        expression: "item.date"
      }
    })], 1)]), _vm._v(" "), _c("div", {
      staticClass: "ruleitem"
    }, [_c("div", {
      staticClass: "itemlabel"
    }, [_vm._v("扣款金额")]), _vm._v(" "), _c("div", {
      staticClass: "itemvalue"
    }, [_vm._v("\n                    " + _vm._s(item.money) + "\n                  ")])]), _vm._v(" "), _c("div", {
      staticClass: "ruleitem"
    }, [_c("div", {
      staticClass: "itemlabel"
    }, [_vm._v("拆单数")]), _vm._v(" "), _c("div", {
      staticClass: "itemvalue"
    }, [_vm._v("\n                    " + _vm._s(item.splitnum) + "\n                  ")])])]), _vm._v(" "), _c("div", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.splitmoney.length > 0,
        expression: "item.splitmoney.length > 0"
      }],
      staticClass: "ruleinfo"
    }, [_c("el-table", {
      attrs: {
        data: item.splitmoney
      }
    }, [_c("el-table-column", {
      attrs: {
        label: "序号",
        type: "index",
        width: "200px"
      }
    }), _vm._v(" "), _c("el-table-column", {
      attrs: {
        prop: "prop",
        label: "扣款金额"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(scope) {
          return [_vm._v("\n                      " + _vm._s(scope.row.money) + "\n                    ")];
        }
      }], null, true)
    })], 1)], 1)]);
  }), 0)]), _vm._v(" "), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: _vm.closeRule
    }
  }, [_vm._v("关闭")])], 1)])], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;